module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"parameters\">\n	")
    ;  if (widget.parameters.groupBy && widget.parameters.groupBy.length) { 
    ; __append("\n		<div class=\"flex\">\n			<div class=\"flex-item\">\n				<label>\n					Группировка <br />\n					")
    ; 
					var selected = widget.parameters.groupBy;
					if (_.isArray(widget.parameters.groupBy) || _.isObject(widget.parameters.groupBy)) {
						selected = JSON.stringify(widget.parameters.groupBy);
					} 
    ; __append("\n					<control type=\"select\" target=\"parameters.groupBy\" source=\"groups\" selected=\"")
    ; __append(escapeFn( selected ))
    ; __append("\" on-select=\"onGroupBySelect\" />\n				</label>\n			</div>\n		</div>\n	")
    ;  } 
    ; __append("\n\n\n    <div class=\"flex\">\n        <div class=\"flex-item\">\n            <label>\n                С даты<br />\n                <control type=\"datepicker\" target=\"parameters.fromDate\"  on-select=\"onGroupBySelect\" />\n            </label>\n        </div>\n    </div>\n\n    <div class=\"flex\">\n        <div class=\"flex-item\">\n            <label>\n                По дату<br />\n                <control type=\"datepicker\" target=\"parameters.toDate\"  on-select=\"onGroupBySelect\" />\n            </label>\n        </div>\n    </div>\n\n	<div class=\"flex\">\n		<div class=\"flex-item\">\n			<label>\n				Район\n			</label><br/>\n			<control type=\"popup-select\" target=\"parameters.districts\"\n					 source=\"districtsSource\"\n					 filter=\"")
    ; __append(escapeFn( JSON.stringify(widget.districtFilter) ))
    ; __append("\"\n					 html-placeholder=\"Фильтр по культуре\"\n					 title-key=\"value\"\n					 value-key=\"id\"\n					 multiple/>\n		</div>\n	</div>\n\n    <hr/>\n    <button on-click=\"onCreateClick\" data-format=\"")
    ; __append(escapeFn( Reports.Format.Html ))
    ; __append("\">Создать</button>\n    <button on-click=\"onDownloadExcelClick\">Скачать в формате Excel</button>\n</div>\n\n")
  }
  return __output.join("");

}